import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { WizardTabs } from '../WizardTabs/WizardTabs'
import {
  NEW_DESIGN_BUTTON_PROPS,
  NEW_DESIGN_BUTTON_PROPS_V2,
  SOCIAL_MEDIA_CARD_OVERRIDES,
  SOCIAL_MEDIA_CATEGORIES,
  SOCIAL_MEDIA_CHANNELS,
  SOCIAL_MEDIA_CHANNELS_V2,
  SOCIAL_MEDIA_TABS,
} from '../constants'
import {
  ChannelKeyType,
  CREATE_NEW_EXCLUDED_CHANNELS,
  SocialMediaCategories,
  SocialMediaTabs,
  VIRTUAL_MARKETER_CREATE_NEW_EXCLUDED_CHANNELS,
} from '../Types'
import { useEffect, useState } from 'react'
import { Common } from './Common'
import { NewDesignButton, NewDesignButtonV2, WizardButton, WizardCard } from '../WizardButton/WizardButton'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { NewDesignListItem } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItem/ListItem'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { WizardCategoryCardGrid } from '../WizardCategoryCard/WizardCategoryCard'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

export const SocialMedia = ({ ...props }: SectionProps) => {
  const subCategory = props.subCategory as SocialMediaCategories
  const setSubCategory = props.setSubCategory

  const [selectedTab, setSelectedTab] = useState<SocialMediaTabs>('popular')
  const channels = SOCIAL_MEDIA_CHANNELS[selectedTab]
  const newDesignButtonProps = NEW_DESIGN_BUTTON_PROPS[selectedTab]
  const { isMobile } = useResponsiveDesign()
  const isVirtualMarketer = useCurrentWorkspace()?.is_virtual_marketer

  const excludedChannels: readonly ChannelKeyType[] = isVirtualMarketer
    ? VIRTUAL_MARKETER_CREATE_NEW_EXCLUDED_CHANNELS
    : CREATE_NEW_EXCLUDED_CHANNELS

  useEffect(() => {
    props.searchRef?.current?.focus()
  }, [selectedTab, props.searchRef])

  if (!isMobile) {
    if (subCategory) {
      const newDesignButtonPropsV2 = NEW_DESIGN_BUTTON_PROPS_V2[subCategory]
      const categoryTitle = SOCIAL_MEDIA_CATEGORIES.find((c) => c?.name === subCategory)?.label

      return (
        <div className={Styles.commonSectionContainer}>
          <div className={Styles.marginTop10}>
            <WizardCategoryCardGrid heading={`What ${categoryTitle} content do you want to make?`}>
              {SOCIAL_MEDIA_CHANNELS_V2[subCategory]
                .filter((channel) => !isVirtualMarketer || !excludedChannels.includes(channel))
                .map((channel) => (
                  <WizardButton
                    key={channel}
                    channelKey={channel}
                    version={2}
                    size="lg"
                    cardInfoOverride={SOCIAL_MEDIA_CARD_OVERRIDES}
                    {...props}
                  />
                ))}
              {newDesignButtonPropsV2 && <NewDesignButtonV2 {...newDesignButtonPropsV2} size="lg" />}
            </WizardCategoryCardGrid>
          </div>
        </div>
      )
    }
    return (
      <div className={Styles.commonSectionContainer}>
        <WizardCategoryCardGrid heading="Which platform do you want to create content for?">
          {SOCIAL_MEDIA_CATEGORIES.map((category) => (
            <WizardCard
              size="md"
              key={category.name}
              title={category.label}
              image={category.image}
              onPress={() => setSubCategory(category.name)}
              {...props}
            />
          ))}
        </WizardCategoryCardGrid>
        <div className={Styles.commonInnerSection}>
          <WizardCategoryCardGrid heading="Popular">
            <WizardButton title="LinkedIn Post" channelKey="linkedin-post" version={2} size="lg" {...props} />
            <WizardButton
              title="Instagram Post"
              channelKey="instagram-portrait-post"
              version={2}
              size="lg"
              {...props}
            />
            <WizardButton title="Instagram Story" channelKey="instagram-story" version={2} size="lg" {...props} />
            <WizardButton title="Instagram Reel" channelKey="instagram-reel" version={2} size="lg" {...props} />
          </WizardCategoryCardGrid>
        </div>
      </div>
    )
  }

  return (
    <div>
      <WizardTabs<SocialMediaTabs> tabs={SOCIAL_MEDIA_TABS} onSelectTab={setSelectedTab} selectedTab={selectedTab} />
      <Common channels={channels} {...props}>
        <ResponsiveDesign.Mobile>
          <NewDesignListItem {...newDesignButtonProps} />
        </ResponsiveDesign.Mobile>
        <ResponsiveDesign.Desktop>
          <NewDesignButton {...newDesignButtonProps} size="lg" />
        </ResponsiveDesign.Desktop>
      </Common>
    </div>
  )
}
